import { useState } from 'react';

import { ProfileScreen } from '@/screens/ProfileScreen';
import { useGame } from '@/store/game';

import { HotseatSetup } from './HotseatSetup';
import type { LobbyMode } from './ModePicker';
import { ModePicker } from './ModePicker';
import { MultiSetup } from './MultiSetup';

/** Куда ушли с развилки. `null` — сама развилка. */
type Step = LobbyMode | 'profile';

/** Ещё не в комнате: сперва режим, потом свой сценарий на каждый. */
export function PreRoomLobby() {
  const [step, setStep] = useState<Step | null>(null);
  // Комната, в которую не пустили: код из startapp или из localStorage
  // подключается ещё в bootstrap, и без этой строки отказ хендшейка
  // (`not_allowed` опоздавшему, `no_room` после завершённой партии)
  // выглядел бы как приложение, открывшееся не туда и молча.
  const fatal = useGame((s) => s.fatal);
  const back = () => setStep(null);

  if (step === 'hotseat') return <HotseatSetup onBack={back} />;
  if (step === 'multi') return <MultiSetup onBack={back} />;
  if (step === 'profile') return <ProfileScreen onBack={back} />;
  return (
    <ModePicker
      onSelect={setStep}
      onProfile={() => setStep('profile')}
      {...(fatal === null ? {} : { notice: fatal })}
    />
  );
}
